import {GROUP_BY} from './aggregations';
import DatasetAttributeModel from './dataset_attribute';
import {ATTRIBUTES} from "../../../../utils/query_utils";

export default class DimensionModel extends DatasetAttributeModel {
    type = ATTRIBUTES.DIMENSION;
    aggregation = GROUP_BY;

    get sql() {
        return this.column.sqlName;
    }
}
